export default __webpack_public_path__ + "static/media/240.1ecafd5d.jpg";